/* eslint-disable global-require */
import Vue from 'vue'
import { Icon } from 'leaflet'
import 'leaflet/dist/leaflet.css'
// eslint-disable-next-line import/no-unresolved
import { library } from '@fortawesome/fontawesome-svg-core'
import { faTv, faCoffee } from '@fortawesome/free-solid-svg-icons'
import { faTwitter, faGithub } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import numeral from 'numeral'
import numFormat from 'vue-filter-number-format'

import App from './App.vue'
import router from './router'

library.add(faTv)
library.add(faCoffee)
library.add(faTwitter)
library.add(faGithub)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.filter('numFormat', numFormat(numeral))

// eslint-disable-next-line no-underscore-dangle
delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})

Vue.config.productionTip = false

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app')
